(() => {
  const flag = 'data-blanket-price-labels-ready';
  if (document.documentElement.hasAttribute(flag)) return;
  const data = document.querySelector('[data-blanket-price-labels]');
  if (!data) return;
  let prices;
  try {
    prices = JSON.parse(data.textContent);
  } catch (error) {
    console.warn('Blanket option price labels could not be loaded.', error);
    return;
  }
  document.documentElement.setAttribute(flag, '');

  const updateLabels = () => {
    document.querySelectorAll('[data-blanket-options]').forEach((picker) => {
      const selectedStyle = picker.querySelector('input[name="Style"]:checked');
      if (!selectedStyle) return;
      picker.querySelectorAll('input[name="Style"]').forEach((input) => {
        const label = Array.from(picker.querySelectorAll('label[for]')).find(
          (element) => element.htmlFor === input.id,
        );
        const text = label && Array.from(label.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
        const value = prices.styles[input.value];
        if (text && value && text.textContent.trim() !== value) text.textContent = `${value} `;
        const detail = prices.materialDetails?.[input.value];
        if (label && detail) {
          let guidance = label.querySelector('[data-blanket-material-guidance]');
          if (!guidance) {
            guidance = document.createElement('span');
            guidance.className = 'blanket-material-guidance';
            guidance.setAttribute('data-blanket-material-guidance', '');
            label.appendChild(guidance);
          }
          if (guidance.textContent !== detail) guidance.textContent = detail;
        }
      });
      const select = picker.querySelector('select[name="options[Size]"]');
      const sizes = prices.sizes[selectedStyle.value];
      if (!select || !sizes) return;
      Array.from(select.options).forEach((option) => {
        const size = sizes[option.value];
        if (!size || option.disabled) return;
        const detail = prices.sizeDetails[option.value];
        const value = `${option.value}${detail ? ` - ${detail}` : ''}${size.surcharge ? ` (${size.surcharge})` : ''}`;
        if (option.textContent !== value) option.textContent = value;
      });
      const context = picker.querySelector('[data-blanket-size-context]');
      const detail = prices.sizeDetails[select.value] || '';
      if (context && context.textContent !== detail) context.textContent = detail;
      const display = picker.querySelector('[data-blanket-size-display]');
      const value = picker.querySelector('[data-blanket-size-value]');
      const caption = picker.querySelector('[data-blanket-size-caption]');
      const surcharge = picker.querySelector('[data-blanket-size-surcharge]');
      const size = sizes[select.value];
      if (display && value && caption && surcharge && size) {
        if (value.textContent !== select.value) value.textContent = select.value;
        if (caption.textContent !== detail) caption.textContent = detail;
        if (surcharge.textContent !== size.surcharge) surcharge.textContent = size.surcharge;
        surcharge.hidden = !size.surcharge;
        display.hidden = false;
        select.setAttribute('data-blanket-size-ready', '');
      } else {
        if (display) display.hidden = true;
        select.removeAttribute('data-blanket-size-ready');
      }
    });
  };

  let frame;
  const scheduleUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      updateLabels();
    });
  };
  // The theme rewrites dropdown labels after variant and availability changes.
  const observer = new MutationObserver(scheduleUpdate);
  document.querySelectorAll('[data-blanket-options]').forEach((picker) => {
    observer.observe(picker.parentElement, { childList: true, characterData: true, subtree: true });
  });
  document.addEventListener('change', scheduleUpdate);
  updateLabels();
})();
